import * as React from 'react'

import {
  Content as ContactSchoolContent,
  Step as ContactSchoolStep,
} from 'main/components/lead/ContactSchoolModal'
import { ScheduleTourModal_school } from '../../common/gql'
import { IContactStep } from '../../types'

interface IProps {
  school: ScheduleTourModal_school
  onChangeStep: (step: IContactStep) => void
  onComplete: () => void
}

export default function Contact(props: IProps) {
  const { school, onChangeStep, onComplete } = props
  const [contactSchoolStep, setContactSchoolStep] = React.useState<ContactSchoolStep | null>(null)

  return (
    <ContactSchoolContent
      schoolId={school.id}
      step={contactSchoolStep}
      onChangeStep={handleChangeStep}
      onDone={onComplete}
    />
  )

  function handleChangeStep(newContactSchoolStep: ContactSchoolStep | null) {
    setContactSchoolStep(newContactSchoolStep)
    onChangeStep({
      __stepname: 'contact',
      contactSchoolStep: newContactSchoolStep,
    })
  }
}
